export const findMeetingTimesConstants = {
    APPNAME_HEADERNAME: 'x-findmeetingtimes-appname',
    APPNAME_HEADERVALUE: 'owa-react',
    SCENARIONAME_HEADERNAME: 'x-findmeetingtimes-appscenario',
    RETURNCHRONOLOGICALRESULTS_HEADERNAME: 'x-returnchronologicalresults',
    RETURNCHRONOLOGICALRESULTS_HEADERVALUE: 'true',
    RETURNACCOMMODATIONS_HEADERNAME: 'x-returnaccommodations',
    RETURNACCOMMODATIONS_HEADERVALUE: 'true',
    USEPREFERREDMEETINGTIMES_HEADERNAME: 'x-usepreferredmeetingtimes',
    USEPREFERREDMEETINGTIMES_HEADERVALUE: 'true',
    FMT_ENDPOINT_URL: 'Scheduling/api/v1.0/me/findmeetingtimes',
    FMT_ENDPOINT_URLB2: 'SchedulingB2/api/v1.0/me/findmeetingtimes',
    DEBUGINFO_HEADERNAME: 'prefer',
    DEBUGINFO_HEADERVALUE: 'returndebuginfo',
};

export const getRoomAvailabilityConstants = {
    APPNAME_HEADERNAME: 'x-getroomavailability-appname',
    APPNAME_HEADERVALUE: 'owa-react',
    SCENARIONAME_HEADERNAME: 'x-getroomavailability-appscenario',
    ENDPOINT_URL: 'Scheduling/api/v1.0/me/getroomavailability',
    ENDPOINT_URLB2: 'SchedulingB2/api/v1.0/me/getroomavailability',
};
